export const announcementQuestionnaireStatuses = Object.freeze({
  Draft: 1,
  Submitted: 2,
  Published: 3,
});
